// extracted by mini-css-extract-plugin
export default {"container":"yq-z","ratingLayout":"zq-z","ratingLabel":"Aq-z","nonInteractiveRatingLabel":"Bq-z"};